import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
} from '@mui/icons-material';

export interface ConfirmationField {
  label: string;
  value: string | number;
  bold?: boolean;
}

export interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message?: string;
  fields?: ConfirmationField[];
  movementType?: 'entry' | 'exit';
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  fields = [],
  movementType,
  onConfirm,
  onCancel,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        {/* Movement Type */}
        {movementType && (
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
            <Chip
              icon={movementType === 'exit' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
              label={movementType === 'exit' ? 'Sortie de Stock' : 'Entrée de Stock'}
              color={movementType === 'exit' ? 'error' : 'success'}
              variant="filled"
            />
          </Box>
        )}

        {/* Message */}
        {message && (
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            {message}
          </Typography>
        )}

        {/* Fields Table */}
        {fields.length > 0 && (
          <Table size="small">
            <TableBody>
              {fields.map((field, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontWeight: 500 }}>{field.label}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: field.bold ? 700 : 400 }}>
                    {field.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={loading}>
          {loading ? 'Traitement...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
